import React from 'react';
import { ParagraphText } from './ParagraphText';
import { ParagraphTitle } from './ParagraphTitle';

export interface ICoverParagraphViewItemProps {
  title: string | null | undefined;
  text: string | null | undefined;
}

export function CoverParagraphViewItem(props: ICoverParagraphViewItemProps) {
  const { title, text } = props;
  return (
    <div>
      <section>
        <ParagraphTitle title={title} />
        <ParagraphText text={text} />
      </section>
    </div>
  );
}
